import React, { useState } from "react";
import { Paper } from "@material-ui/core";
import { Select } from "@components/formx";
import { useLocale } from "@hooks";
import { useGetUserSelectUsersQuery } from "@bonliva-crm/graphql";

export function ResponsiblePersonSelect() {
  const [options, setOptions] = useState<LabelValue[]>([]);
  const { locale } = useLocale();

  useGetUserSelectUsersQuery({
    onCompleted(data) {
      setOptions(
        data.users
          .filter((x) => x.Enabled)
          .map((x) => ({
            label: x.Name,
            value: x._id
          }))
      );
    }
  });

  return (
    <Paper style={{ padding: 16 }}>
      <div style={{ width: "50%" }}>
        <Select
          fullWidth
          label={locale["Responsible BA"]}
          name="responsiblePerson"
          options={options}
          transformValue={(x) => (x ? x : null)}
        />
      </div>
    </Paper>
  );
}
